const onInitialize = async ({ state, actions, effects }) => {
  state.menu.data = mainMenuTree.map((item, index) => {
    return { ...item, active: false, id: index }
  })

  state.menu.adverts = await effects.menu.getAdvertBlock()
  state.menu.adverts.isLoad = true
  return
}

export default onInitialize
